import { render, staticRenderFns } from "./AppSectionLoader.vue?vue&type=template&id=7b5b6f39"
import script from "./AppSectionLoader.vue?vue&type=script&lang=js"
export * from "./AppSectionLoader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports